import { DateLib } from "../classes/DateLib.js";
/**
 * The label for the day gridcell when the calendar is not interactive.
 *
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
export function labelGridcell(date, /** The modifiers for the day. */
modifiers, options, dateLib) {
  var label = (dateLib !== null && dateLib !== void 0 ? dateLib : new DateLib(options)).format(date, "PPPP");
  if (modifiers !== null && modifiers !== void 0 && modifiers.today) {
    label = "Today, ".concat(label);
  }
  return label;
}